<template>
  <div popup-msg v-if="msg" @click="close">
    <article>
      <a class="btn-x" @click="close"></a>
      <p v-html="this.$store.state.msg"></p>
      <a class="btn-ok" @click="close"></a>
    </article>
  </div>
</template>

<script>
export default {
  name: 'PopupMsg',
  computed: {
    msg() {
      if (!this.$store.state.msg) return false;
      return this.$store.state.msg;
    },
  },
  methods: {
    close(e) {
      if (e) e.stopPropagation();
      this.$store.commit('offMsg');
    },
  },
};
</script>

<style lang="less">
  @import "../less/proj";
  .mob{
    [popup-msg]{ .fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.6);
      article{.wh(700,350); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .contain("@{pc}/p2/popup-message.png");
        p{.fs(24); .lh(30); color:white; .tc; .pt(80);}
        .btn-ok{.wh(311,73); .contain("@{pc}/p2/popup-btn-ok.png"); .block; .mh-c; .abs; .b(66); .l(50%); .ml(-156); .-box;
          &:after{.cnt; .wh(100%); .abs; .t(0); .l(0); transition: .5s; .-box; }
        }
        .btn-x{.block; .wh(70,70); .r(0); .t(0); .abs;}
      }
    }
  }
  .pc{
    [popup-msg]{ .fix; .t(0); z-index: 1000; .wh(100%); background:rgba(0,0,0,0.6);
      article{.wh(800px,400px); .abs; .l(50%); .t(50%); transform: translate(-50%,-50%); .contain("@{pc}/p2/popup-message.png");
        p{.fs(24px,40px); color:white; .tc; .pt(100px);}
        .btn-ok{.wh(311px,73px); .bg("@{pc}/p2/popup-btn-ok.png"); .block; .mh-c; .abs; .b(66px); .l(50%); .ml(-156px); .-box;
          &:after{.cnt; .wh(100%); .abs; .t(0); .l(0); transition: .5s; .-box; }
          &:hover{
            &:after{.-a(#FF0000);}
          }
        }
        .btn-x{.block; .wh(70px,70px); .r(0); .t(0); .abs;}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PopupMsg.vue